import React from 'react';
import { User, Store, BrandRequest, Brand } from '../data/types';
import { Header } from '../components/layout/Header';
import { DashboardCalendar } from '../components/dashboard/DashboardCalendar';
interface BookingCalendarPageProps {
  user: User;
  stores: Store[];
  brandRequests: BrandRequest[];
  onLogout: () => void;
  onNavigate: (view: any) => void;
  activityLog?: any;
  brands?: Brand[];
  onSelectStore?: (store: Store) => void;
}
export function BookingCalendarPage({
  user,
  stores,
  brandRequests,
  onLogout,
  onNavigate,
  activityLog,
  brands,
  onSelectStore
}: BookingCalendarPageProps) {
  const draftCount = brandRequests.filter(r => r.status === 'draft').length;
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1366">
      <Header user={user} onLogout={onLogout} currentView="booking-calendar" onNavigate={onNavigate} draftCount={draftCount} stores={stores} brands={brands} brandRequests={brandRequests} activityEntries={activityLog?.entries} unreadCount={activityLog?.unreadCount} onMarkAllRead={activityLog?.markAllAsRead} onMarkRead={activityLog?.markAsRead} onSelectStore={onSelectStore} data-id="element-1367" />
      <main className="flex-1 overflow-auto" data-id="element-1368">
        <DashboardCalendar stores={stores} data-id="element-1369" />
      </main>
    </div>;
}